<template>
  <div class="product_wrapper">
    <h1>{{ title }}</h1>
    <div class="product_content content_wrapper">
      <div class="product_item" v-for="item in productData" :key="item.id">
        <img :src="item.imgSrc" :alt="item.name" />
        <h3>{{ item.name }}</h3>
        <a :href="item.link" target="_blank">了解更多 ></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '系列产品',
    },
    productData: {
      type: Array,
      default: [],
    },
  },
};
</script>

<style lang="scss" scoped>
.product_wrapper {
  width: 100%;
  padding: 70px 0px 0px 0px;
  background: #f6f7f8;
  h1 {
    text-align: center;
    font-size: 28px;
    font-weight: 400;
    color: #0d0e24;
    margin-bottom: 40px;
  }
  .product_content {
    display: grid;
    grid-template-columns: repeat(6,16%);
    justify-content: space-between;
    grid-row-gap: 20px;
    .product_item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-color: #fff;
      padding: 30px 10px;
      img {
        max-width: 150px;
      }
      h3 {
        font-size: 22px;
        font-weight: 400;
        color: #000000;
        margin-top: 48px;
        margin-bottom: 18px;
      }
      p {
        font-size: 14px;
        font-weight: 300;
        color: #6e6e66;
      }
      a {
        margin-top: 30px;
        font-size: 16px;
        font-weight: 300;
        color: #4173fb;
        text-decoration: none;
      }
      &:hover {
        transform: scale(1.05);
        transition: scale 0.5s ease-in-out;
      }
    }
  }
}
</style>